export const translationsZhTw = {
	//Brand
	'TicketShooter':'票券印鈔機',
	//Stage
	'development':'開發版',
	'staging':'測試版',
	'beta':'Beta版',
	//Header
	'Settings': '設定',
	'Create Plan':'建立票券',
	'Plan List':'票券清單',
	'Launch Plan':'發行票券',
	//Settings
	'Fanpage ID':'Facebook粉絲團ID',
	'The ticket will send from this fanpage to customer. (Need further settings)':'票券將會由此粉絲頁推送給顧客(必須為數字ID，需要請Sharelike額外設定)',
	'KOTSMS':'簡訊王',
	'Account':'Account',
	'Password':'Password',
	'Send SMS':'是否寄送註冊簡訊',
	'SMS content':'簡訊內容',
	'Use %URL% to insert register link (without space)':'插入%URL%以代表顧客註冊連結(中間不要有空白)',
	'SMS length: {smsLength}, need {smsAmount} SMS. %URL% reserved 26 chars':'簡訊字數 {smsLength}字，需要 {smsAmount}則簡訊。 %URL%保留26字',
	'The register sms will be sent from this KOTSMS account.':'註冊簡訊將由此簡訊王帳號寄出。',
	'Save':'儲存',
	'Saved Successfully!':'儲存成功!',
	'Saved Failed':'儲存失敗',
	'Changes have not been saved':'更動尚未儲存',
	//Create Plan
	'Plan Name':'票券名稱',
	'Plan Type':'票券種類',
	'Please select One':'請選擇一個',
	'Ticket':'票券',
	'Card':'卡片',
	'Each type has a unique view.':'不同種類的票券呈現方式不同',
	'Plan Description':'票券描述',
	'The name of the ticket.':'會顯示在顧客手機上的票券名稱。',
	'Detailed usage of the ticket.':'票券的注意事項與使用方式。',
	'Plan Expiration':'使用期限',
	'Ticket can not be used after that day.':'本票券能被使用的最後日期',
	'Plan Front Image (required)':'正面圖片(必填)',
	'Plan Back Image (Back)':'背面圖片',
	'Plan Redeemed Image (Suggested)':'核銷圖片(建議)',
	'Choose File':'選取檔案',
	'Browse':'瀏覽',
	'Submit':'送出',
	'Advanced Settings':'進階設定',
	'Push Message Template':'推播模板',
	'Should be a valid JSON Object':'需為 JSON 物件',
	'Find your plan here:':'您的票券在此:',
	'Ticket Redeemed Image':'Redeem',
	'Ticket Back Image':'Back',
	'Ticket Front Image':'Front',
	'Creating Plan Failed':'票券建立失敗',
	'Waiting for uploading...':'正在上傳...請稍等...', 

	'Dynamic Coupon Code':'動態折扣碼',
	'Import Dynamic Coupon Code List':'匯入動態優惠代碼',
	'Upload Batch CSV File or Paste Coupon Code List':'上傳 CSV 檔案或貼上優惠代碼清單',
	'The amount of coupon code will be the amount of tickets you can issue':'優惠代碼的數量會決定本票券的發行數量上限',
	'Already imported {number} codes.':'已匯入 {number}個優惠代碼',
	'Plan Format':'格式',
	'Text code':'文字代碼',
	'Barcode CODE39':'一維條碼 CODE39（尚未啟用）',
	'QRcode':'二維條碼 QRcode (尚未啟用)',
	'Scratch Card':'刮刮卡',

	//Plan View
	'Invalid URL':'不存在此票券',
	'Ticket Provider:':'粉絲團ID:',
	'Input Phone Number':'請輸入手機',
	'Please Input valid phone number':'請輸入正確格式的手機號碼。',
	'Issue Ticket':'註冊並給券',
	'Push Ticket':'推送票券',
	'SMS turned Off':'簡訊已關閉',
	'SMS turned On':'簡訊已開啟',
	'Balance: {value}':'目前餘額: {value}點',
	'KOTSMS not set':'未設定簡訊王帳密',
	'Ticket has issued successfully':'票券成功送出。',
	'Check if Registered':'檢查是否已註冊',
	'Check if customer registered':'檢查顧客是否註冊過',
	'Customer HAS fully registered.':'顧客已完整註冊',
	'Customer has NOT registered.':'顧客未註冊',
	'Customer HAS registered, but HAS NOT bound facebook messenger.':'顧客已註冊，但尚未綁定Messenger',
	'Customer HAS registered.\nRegister link:\n ':'顧客已註冊\n註冊連結:\n ',
	'Get QRcode':'產生註冊 QRcode',
	'Get Register Link':'取得Messenger綁定連結',
	'Upload Batch CSV File or Paste Phone List':'請上傳CSV檔或貼上手機清單',
	'Batch Issue Ticket':'批次推送',
	'Going to use {amount} KOTSMS points':'即將使用簡訊王點數 {amount}點',
	'Already imported {number} phones.':'已匯入 {number} 支手機號碼',
	'Issuing... Do not close window.':'正在推送... 請勿關閉視窗',
	'Issuing... {progress} items issued':'正在推送... 已推送 {progress} 個項目',
	'Batch issue {size} complete':'完成推送 {size} 個項目',
	'This plan is issued from stock but no stock tickets':'這是從庫存發送的票券，但找不到庫存',
	'This plan is issued from stock.':'這是從庫存發送的票券',
	'There are {value} tickets in stock':'庫存尚有 {value}張',
	

	//Modal
	'Confirm':'確認',
	//Ticket List
	'Ticket List':'票券清單',
	//Ticket View
	'Loading Ticket...':'Loading...',
	'Invalid Ticket':'不存在此票券',
	'Ticket ID:':'序號:',
	'Expiration:':'使用期限:',
	'Staff Redeem':'票券核銷處',
	'Long Press':'長按',
	'Long Press to Redeem':'按住按鈕以核銷',
	'Success':'成功',
	'Redeemded Successfully':'已成功完成核銷',
	'The Ticket has been redeemed.':'本票券已核銷',
	'Redeem failed':'核銷失敗',
	'Can not redeem, the Ticket has gone.':'無法核銷。此票券不存在或已被核銷',
	//Footer
	'Powered by Sharelike.':'本服務由 Sharelike.提供',
	
	
	

};